import { gql, useQuery } from '@apollo/client';
import useLoginState from '../../core/hooks/useLoginState';
import useUserBranches from '../../core/queries/useUserBranches';
import type { FutureStockQuantities, StockQuantity } from '../types';

export const stockQuantityQuery = gql`
    query stockQuantity($store: ID!, $sku: String!, $location: String!) {
        singleStockQuantity(store: $store, sku: $sku, location: $location) {
            store
            sku
            location
            quantity
            nextAvailability
        }
        productFutureStock(store: $store, sku: $sku, location: $location) {
            store
            sku
            location
            quantities {
                quantity
                date
            }
        }
    }
`;

const useStockQuantity = ({
    store,
    sku,
    stockLocation,
    skipLoadingStocks,
}: {
    store: string;
    sku: string;
    stockLocation?: string;
    skipLoadingStocks?: boolean;
}) => {
    const isLoggedIn = useLoginState();
    const { mainStock, locationCode } = useUserBranches();

    let location = stockLocation;

    if (!location) {
        location = mainStock?.id ?? locationCode;
    }

    return useQuery<{
        singleStockQuantity: StockQuantity;
        productFutureStock: FutureStockQuantities;
    }>(stockQuantityQuery, {
        variables: {
            store,
            sku,
            location,
        },
        skip: !location || !sku || !isLoggedIn || skipLoadingStocks,
        fetchPolicy: 'cache-first',
    });
};

export default useStockQuantity;
